import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';

const SoundwaveContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 60px;
  background: rgba(0, 0, 0, 0.8);
  z-index: 700;
  overflow: hidden;
`;

const Canvas = styled.canvas`
  width: 100%;
  height: 100%;
`;

const Soundwave = () => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = 60;

    const bars = 200;
    const barWidth = canvas.width / bars;
    const colors = ['#00ffff', '#ff00ff', '#ffaa00', '#00ff00'];
    
    let phase = 0;

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < bars; i++) {
        // Create wave pattern
        const x = i * barWidth;
        const frequency = 0.05 + (i / bars) * 0.03;
        const amplitude = 20 + Math.sin(i * 0.1 + phase) * 10;
        const height = Math.abs(Math.sin(i * frequency + phase) * amplitude);
        
        // Color cycling
        const colorIndex = Math.floor((i + phase * 10) % colors.length);
        const nextColorIndex = (colorIndex + 1) % colors.length;
        const colorMix = ((i + phase * 10) % colors.length) - colorIndex;
        
        // Create gradient
        const gradient = ctx.createLinearGradient(x, 0, x, canvas.height);
        gradient.addColorStop(0, colors[colorIndex] + '88');
        gradient.addColorStop(1, colors[nextColorIndex] + '44');
        
        ctx.fillStyle = gradient;
        
        // Draw bar centered vertically
        const y = (canvas.height - height) / 2;
        ctx.fillRect(x, y, barWidth - 1, height);
      }

      phase += 0.05;
      animationRef.current = requestAnimationFrame(animate);
    };

    animate();

    // Handle resize
    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = 60;
    };

    window.addEventListener('resize', handleResize);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <SoundwaveContainer>
      <Canvas ref={canvasRef} />
    </SoundwaveContainer>
  );
};

export default Soundwave;